// extracted by mini-css-extract-plugin
export default {"newCasesModalContainer":"styles_newCasesModalContainer__Xu8Ln","textInput":"styles_textInput__id1DN","select":"styles_select__I6mgz","ui-spin":"styles_ui-spin__Mz9lj"};